import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";

/**
 * Sticky mobile CTA — appears after hero scroll on mobile only.
 * Hides on the mockup page (form is the CTA), admin pages, and the residential
 * tint page (its inline form is the CTA — the mockup flow would leak visitors).
 */
export default function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const hide = loc.pathname.startsWith("/mockup") || loc.pathname.startsWith("/admin") || loc.pathname === "/services/residential-window-tint";
  if (hide) return null;

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={`md:hidden fixed inset-x-0 bottom-0 z-40 bg-white/95 backdrop-blur-xl border-t border-neutral-200 transition-transform duration-300 ${visible ? "translate-y-0" : "translate-y-full"}`}
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0)" }}
    >
      <div className="flex items-center justify-between gap-3 px-4 py-3">
        <a
          href="tel:+19282730784"
          data-testid="sticky-cta-call"
          data-track="phone_click"
          data-track-location="sticky_mobile"
          className="flex items-center gap-2 flex-1 py-3 px-4 rounded-full border border-neutral-200 text-sm font-semibold"
        >
          <Phone size={16} className="text-[var(--red)]" /> Text Dave
        </a>
        <Link
          to="/mockup"
          data-testid="sticky-cta-mockup"
          data-track="cta_click"
          data-track-location="sticky_mobile"
          className="flex items-center gap-2 flex-1 justify-center py-3 px-4 rounded-full bg-[var(--red)] text-white text-sm font-bold"
          style={{ boxShadow: "0 8px 24px -12px rgba(230,51,41,0.5)" }}
        >
          Free Mockup <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
}
